/** Racore is app-first: only phones & tablets (and the native shell). */
export const TABLET_MAX_WIDTH = 1024;

/**
 * Whether the current device is allowed to use the web app. Native shell always
 * passes; on the web, touch devices (coarse pointer) or narrow viewports
 * (≤ tablet width) pass, while wide desktop/laptop browsers are blocked.
 * Pure so it can be unit-tested without a DOM.
 */
export function isAllowedDevice(opts: {
  isNative: boolean;
  coarsePointer: boolean;
  width: number;
  maxTabletWidth?: number;
}): boolean {
  if (opts.isNative) return true;
  return opts.coarsePointer || opts.width <= (opts.maxTabletWidth ?? TABLET_MAX_WIDTH);
}
